export default __webpack_public_path__ + "static/media/yuletide-logo.af6b78a4.png";